export default "__VITE_ASSET__BVoE2qRb__"